var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 18.8789C10.4087 18.8789 8.88258 18.2468 7.75736 17.1215C6.63214 15.9963 6 14.4702 6 12.8789C6 11.2876 6.63214 9.76148 7.75736 8.63627C8.88258 7.51105 10.4087 6.87891 12 6.87891C13.5913 6.87891 15.1174 7.51105 16.2426 8.63627C17.3679 9.76148 18 11.2876 18 12.8789C18 14.4702 17.3679 15.9963 16.2426 17.1215C15.1174 18.2468 13.5913 18.8789 12 18.8789ZM11 1.87891H13V4.87891H11V1.87891ZM11 20.8789H13V23.8789H11V20.8789ZM3.515 5.80791L4.929 4.39391L7.05 6.51491L5.636 7.92891L3.515 5.80791ZM16.95 19.2429L18.364 17.8289L20.485 19.9499L19.071 21.3639L16.95 19.2429ZM19.071 4.39291L20.485 5.80791L18.364 7.92891L16.95 6.51491L19.071 4.39391V4.39291ZM5.636 17.8289L7.05 19.2429L4.929 21.3639L3.515 19.9499L5.636 17.8289ZM23 11.8789V13.8789H20V11.8789H23ZM4 11.8789V13.8789H1V11.8789H4Z",
    fill: "#42C8A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.878906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.1d399723fc00c09a413e89fcb6758295.svg";
export { ForwardRef as ReactComponent };